import React from 'react';
import { type BuyerLayoutProps } from 'shop-ui/types';

interface ProductSpecPickerProps extends BuyerLayoutProps<Product> {}

export const ProductSpecPicker: React.FC<ProductSpecPickerProps> = (props) => {
    const { __ssr = {} } = props;

    const { product } = __ssr;

    if (!product.spec_metas || product.spec_metas.length === 0) {
        return null;
    }

    return (
        <span>
            {product.spec_metas.map((i, idx) => (
                <div key={i.group_name + idx}>
                    <label htmlFor={i.group_name}>
                        <span className="ssr-hidden">{i.group_name}</span>
                    </label>
                    <div className="skeleton skeleton--ssr skeleton--sm">
                        <select
                            name={i.group_name}
                            id={i.group_name}
                            className="ssr-hidden"
                        >
                            {i.specs.map((option) => (
                                <option
                                    key={option.id}
                                    value={`${option.name}-${option.id}`}
                                >
                                    {option.name}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            ))}
        </span>
    );
};
